import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3d68e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Rider Add")
  ])
], -1))
const _hoisted_4 = { class: "col-5 mt-4" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Name", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Email", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Mobile Number", -1))
const _hoisted_11 = { class: "form-floating" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "DOB", -1))
const _hoisted_13 = { class: "form-floating" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Postal Code", -1))
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Bank Account Title", -1))
const _hoisted_17 = { class: "form-floating" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Bank Account Number", -1))
const _hoisted_19 = { class: "form-floating" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Bank Sort Code", -1))
const _hoisted_21 = { class: "form-floating" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Bank other detail", -1))
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is buzy ", -1))
const _hoisted_25 = { class: "form-check" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " availability ", -1))
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Active ", -1))
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Block ", -1))
const _hoisted_31 = { class: "form-floating" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Country", -1))
const _hoisted_34 = { class: "form-floating" }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City", -1))
const _hoisted_37 = { class: "form-floating" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Bicycle" }, " Bicycle ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "eBike" }, " eBike ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Car" }, " Car ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Scooter" }, " Scooter ", -1))
const _hoisted_42 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Account Type", -1))
const _hoisted_44 = { class: "form-floating" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingPassword" }, "Password", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.rider_name) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Per Unit Price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_name]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.rider_email) = $event)),
              class: "form-control",
              placeholder: "Base Price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_email]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.rider_phone) = $event)),
              class: "form-control",
              placeholder: "Base Unit",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_phone]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.rider_dob) = $event)),
              class: "form-control",
              placeholder: "Base Unit"
            }, null, 512), [
              [_vModelText, $setup.data.rider_dob]
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.rider_postal_code) = $event)),
              class: "form-control",
              placeholder: "Base Unit",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_postal_code]
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.bank_account_title) = $event)),
              class: "form-control",
              placeholder: "Base Unit"
            }, null, 512), [
              [_vModelText, $setup.data.bank_account_title]
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.bank_account_number) = $event)),
              class: "form-control",
              placeholder: "Base Unit"
            }, null, 512), [
              [_vModelText, $setup.data.bank_account_number]
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.bank_sort_code) = $event)),
              class: "form-control",
              placeholder: "Base Unit"
            }, null, 512), [
              [_vModelText, $setup.data.bank_sort_code]
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.bank_other_detail) = $event)),
              class: "form-control",
              placeholder: "Base Unit"
            }, null, 512), [
              [_vModelText, $setup.data.bank_other_detail]
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.is_buzy) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_buzy]
            ]),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.data.availability_status) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.availability_status]
            ]),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.data.is_active) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_active]
            ]),
            _hoisted_28
          ]),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.data.is_block) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_block]
            ]),
            _hoisted_30
          ]),
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.data.country_id) = $event)),
              class: "form-control",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: country.id,
                  value: country.id
                }, _toDisplayString(country.name), 9, _hoisted_32))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.data.country_id]
            ]),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.data.city_id) = $event)),
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city.id,
                  value: city.id
                }, _toDisplayString(city.name), 9, _hoisted_35))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.data.city_id]
            ]),
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.data.vehicle_type) = $event)),
              class: "form-control",
              required: ""
            }, _hoisted_42, 512), [
              [_vModelSelect, $setup.data.vehicle_type]
            ]),
            _hoisted_43
          ]),
          _createElementVNode("div", _hoisted_44, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.data.rider_password) = $event)),
              class: "form-control",
              placeholder: "Password",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_password]
            ]),
            _hoisted_45
          ]),
          _hoisted_46
        ], 32)
      ])
    ])
  ]))
}